import stockMessage from "../../helpers/stockMessage/stockMessage";
import stockMessageInputs from "../stock-status/stockMessageInputs";

export default function setItemStockStatus({ variant, quantity }) {
  const allocatedComponents = window.cartData?.allocatedComponents || {};
  const inputs = stockMessageInputs({
    variant,
    quantityRequested: quantity,
    allocatedComponents,
  });

  const messages = {
    inStock: {
      inStock: true,
      orderable: true,
    },
    lowStock: {
      inStock: true,
      orderable: true,
    },
    outOfStock: {
      inStock: false,
      orderable: false,
    },
    reserveNow: {
      inStock: false,
      orderable: true,
    },
    reserveNowDate: {
      inStock: false,
      orderable: true,
    },
    notifyMe: {
      inStock: false,
      orderable: false,
    },
    notifyMeDate: {
      inStock: false,
      orderable: false,
    },
    madeToOrder: {
      inStock: false,
      orderable: true,
    },
  };

  const message = stockMessage({ ...inputs, messages });

  return {
    ...message,
    backorderDate: inputs.backorderDate,
  };
}
